<template>
    <div class="card">
        <div class="card-checkbox"><CustomCheckbox :id="item.id" v-model="checked" /></div>
        <div class="card-content">
            <span class="card-title">
                {{ item.business.name }}
                <font-awesome-icon icon="arrows-alt-h" class="card-actions--icon" />
                {{ item.object.name }}
            </span>
            <span v-if="item.keys.length && !item.r_verif_all_tags" class="card-summary">
                {{ item.keys.length > 1 ? `${item.keys.length} attributs` : '1 attribut' }} à
                valider
            </span>
            <span v-if="!item.keys.length && !item.r_verif_all_tags" class="card-summary"
                >Aucun attribut à valider</span
            >
            <span v-if="item.r_verif_all_tags" class="card-summary"
                >Tous les attributs à valider</span
            >
            <span v-if="item.r_verif_geom" class="card-summary">Géométrie à valider</span>
            <div class="card-actions">
                <font-awesome-icon
                    title="Modifier"
                    icon="pencil-alt"
                    class="card-actions--icon"
                    @click="handleEdit(item.id)"
                />
                <font-awesome-icon
                    title="Supprimer"
                    icon="trash-alt"
                    class="card-actions--icon alert"
                    @click="handleConfirm(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import CustomCheckbox from '@/components/Checkbox';

export default {
    props: {
        item: { type: Object, required: true },
        selected: [Array],
        handleEdit: { type: Function },
        handleConfirm: { type: Function },
    },
    data() {
        return {
            checked: this._getCheck(this.selected),
        };
    },
    watch: {
        selected(val) {
            this.checked = this._getCheck(val);
        },
        checked(val) {
            this.$emit('selected', { id: this.item.id, checked: val });
        },
    },
    methods: {
        _getCheck(val) {
            return val && val.some((s) => s === this.item.id);
        },
    },
    components: {
        CustomCheckbox,
    },
};
</script>

<style lang="scss"></style>
